import { IGcpAppDispatch } from "../../../redux/store";
import { getDeprecatedUIState, IStoreState } from "../../../redux/rootReducer";
import { IGcpAppIo } from "../../../redux/io";
import { DEM_SELECTED, ORTHOPHOTO_SELECTED } from "../../../tracking/constants";
import { toggleOverlayMode } from "../../../redux/modules/ui/reducer";

export const userClicksOverlaySwitchButton =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const uiState = getDeprecatedUIState(getState());
    trackAction(
      uiState.elevationMapIsVisible ? ORTHOPHOTO_SELECTED : DEM_SELECTED,
    );
    dispatch(toggleOverlayMode());
  };
